import React from 'react';
import { StyledLoading, StyledRetryMessage } from './styled';
import { useRetryMessage } from 'hooks/useRetryMessage';

import leankeepLogo from 'assets/icons/leankeep/leankeep-facility-logo.svg';

export const Loading = () => {
  const retryMessage = useRetryMessage();

  return (
    <StyledLoading>
      <img src={leankeepLogo} alt="Leankeep" />
      {retryMessage && <StyledRetryMessage>{retryMessage}</StyledRetryMessage>}
    </StyledLoading>
  );
};
